<template>
  <div class="content" v-loading="loading">
    <div class="detail-header">
      <div class="pageTitle">追踪稽查详情</div>
      <el-button icon="el-icon-back" @click="backToSearch">返回查询</el-button>
    </div>

    <div v-if="isTrue">
      <div class="blocknote"><span>基本信息</span></div>
      <div class="page-table" v-if="baseData">
        <table width="100%" cellpadding="0" cellspacing="0" border="0">
          <tbody>
            <tr>
              <td>状态</td>
              <td>{{ baseStatusText }}</td>
            </tr>
            <tr>
              <td>标签类型</td>
              <td>{{ baseData.code_name }}</td>
            </tr>
            <tr>
              <td>批号</td>
              <td>{{ baseData.production_batch }}</td>
            </tr>
            <tr>
              <td>包装类型</td>
              <td>{{ baseData.packaging_type }}</td>
            </tr>
            <tr>
              <td>产品代码</td>
              <td>{{ baseData.product_sn }}</td>
            </tr>
            <tr>
              <td>产品名称</td>
              <td>{{ baseData.product_name }}</td>
            </tr>
            <tr>
              <td>产品规格</td>
              <td>{{ baseData.product_specs }}</td>
            </tr>
            <tr>
              <td>产品数量</td>
              <td>{{ baseData.code_total }}</td>
            </tr>
            <tr>
              <td>生产日期</td>
              <td>{{ baseData.production_date }}</td>
            </tr>
            <tr>
              <td>有效日期</td>
              <td>{{ baseData.expiring_date }}</td>
            </tr>
            <tr v-if="withCodeInfo.codeSellsRate">
              <td>开瓶率</td>
              <td>{{ withCodeInfo.codeSellsRate }}%</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="blocknote"><span>物流信息</span></div>
      <div class="page-table last-page">
        <table
          v-for="(item, index) in deliverData"
          :key="`${item.created_at || 'logistics'}-${index}`"
          width="100%"
          cellpadding="0"
          cellspacing="0"
          border="0"
          class="logistics-table"
        >
          <tbody>
            <tr>
              <td>日期</td>
              <td>{{ item.created_at }}</td>
            </tr>
            <tr>
              <td>
                <span v-if="item.status == 1">入库单号</span>
                <span v-if="item.status == 2">调仓单号</span>
                <span v-if="item.status == 3">出货单号</span>
                <span v-if="item.status == 4">调拨单号</span>
                <span v-if="item.status == 5">零售单号</span>
                <span v-if="item.status == 6 || item.status == 7">退货单号</span>
              </td>
              <td>
                <span v-if="item.status == 1 || item.status == 2">
                  {{ item.stock_in_sn }}
                </span>
                <span v-if="item.status == 3 || item.status == 4 || item.status == 5">
                  {{ item.stock_out_sn }}
                </span>
                <span v-if="item.status == 6 || item.status == 7">
                  {{ item.return_goods_sn }}
                </span>
              </td>
            </tr>
            <tr v-if="item.status == 3 && item.order_line_no">
              <td>在线订单单号</td>
              <td>{{ item.order_line_no }}</td>
            </tr>
            <tr v-if="item.status == 3">
              <td>是否赠品</td>
              <td>
                <span v-if="item.isgift == 1">赠品</span>
                <span v-if="item.isgift == 2">非赠品</span>
              </td>
            </tr>
            <tr>
              <td>
                <span v-if="item.status == 1">入库仓库</span>
                <span v-if="item.status == 2">调出仓库</span>
                <span v-if="item.status == 3">出货仓库</span>
                <span v-if="item.status == 4">调出经销商</span>
                <span v-if="item.status == 5">出货人</span>
                <span v-if="item.status == 6 || item.status == 7">退货人</span>
              </td>
              <td>
                <span v-if="item.status == 1">{{ item.warehouse_name }}</span>
                <span v-if="item.status == 2">{{ item.from_warehouse_name }}</span>
                <span v-if="item.status == 3">{{ item.warehouse_name }}</span>
                <span v-if="item.status == 4 || item.status == 5 || item.status == 6 || item.status == 7">
                  {{ item.from_name }}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span v-if="item.status == 1">入库产品</span>
                <span v-if="item.status == 2">调入仓库</span>
                <span v-if="item.status == 3">出库产品</span>
                <span v-if="item.status == 4">调入经销商</span>
                <span v-if="item.status == 5">出货产品</span>
                <span v-if="item.status == 6 || item.status == 7">退货产品</span>
              </td>
              <td>
                <span v-if="item.status == 1">{{ item.product_name }}</span>
                <span v-if="item.status == 2">{{ item.warehouse_name }}</span>
                <span v-if="item.status == 3">{{ item.product_name }}</span>
                <span v-if="item.status == 4">{{ item.to_name }}</span>
                <span v-if="item.status == 5 || item.status == 6 || item.status == 7">
                  {{ item.product_name }}
                </span>
              </td>
            </tr>
            <tr v-if="item.status == 2 || item.status == 3 || item.status == 4">
              <td>
                <span v-if="item.status == 2">入库产品</span>
                <span v-if="item.status == 3">出库客户</span>
                <span v-if="item.status == 4">入库产品</span>
              </td>
              <td>
                <span v-if="item.status == 2 || item.status == 4">{{ item.product_name }}</span>
                <span v-if="item.status == 3">{{ item.from_name }}</span>
              </td>
            </tr>
            <tr v-if="item.remarks">
              <td>备注</td>
              <td>{{ item.remarks }}</td>
            </tr>
            <tr v-if="item.status == 3">
              <td>收货人</td>
              <td>{{ item.to_name }}</td>
            </tr>
            <tr>
              <td>操作人</td>
              <td>{{ item.operator }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="!deliverData.length" class="empty-data">暂无物流记录</div>
      </div>

      <div class="page-table code-table">
        <table width="100%" cellpadding="0" cellspacing="0" border="0">
          <thead>
            <tr>
              <th>{{ big_code_name }}</th>
              <th>{{ middle_code_name }}</th>
              <th>{{ small_code_name }}</th>
              <th>流水号</th>
              <th>变更时间</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in codeData" :key="`${item.logistics_code || 'code'}-${index}`">
              <td :class="item.big_code == form.logistics_code ? 'active' : 'normalClass'">
                {{ item.big_code }}
                <el-tooltip
                  v-if="item.stack_code"
                  class="item"
                  effect="dark"
                  content="代表该物流码有关联虚拟垛标，可通过PDA查询垛标明细"
                  placement="right"
                >
                  <span class="stack" @click="showStack(item.big_code)">垛</span>
                </el-tooltip>
              </td>
              <td :class="item.middle_code == form.logistics_code ? 'active' : 'normalClass'">
                {{ item.middle_code }}
              </td>
              <td :class="item.small_code == form.logistics_code ? 'active' : 'normalClass'">
                <div class="small-code-container">
                  {{ item.small_code }}
                  <el-tooltip
                    v-if="withCodeInfo.codeSells.includes(item.small_code)"
                    :content="withCodeInfo.codeSellsDate[item.small_code] || ''"
                    placement="top"
                  >
                    <img src="@/assets/img/sells.png" alt="已销售" class="sales-icon" />
                  </el-tooltip>
                </div>
              </td>
              <td>{{ item.serialnum }}</td>
              <td>{{ item.updated_at }}</td>
            </tr>
            <tr v-if="!codeData.length">
              <td colspan="5">暂无标签关系</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <stack-view :visible.sync="stackVisible" :logistics_code="stack_logistics_code" />
  </div>
</template>

<script>
import StackView from "../../common/StackView.vue";
import {
  filterLogisticsItems,
  flattenCodeTree,
  getBaseStatusText,
} from "./traceUtils";

export default {
  name: "trace-manage-detail",
  components: {
    StackView,
  },
  data() {
    return {
      form: {
        logistics_code: "",
      },
      baseData: {},
      codeData: [],
      deliverData: [],
      withCodeInfo: {
        codeSells: [],
        codeSellsRate: "",
        codeSellsDate: {},
      },
      big_code_name: "大标",
      middle_code_name: "中标",
      small_code_name: "小标",
      isTrue: false,
      loading: false,
      stackVisible: false,
      stack_logistics_code: "",
    };
  },
  computed: {
    baseStatusText() {
      return getBaseStatusText(this.baseData);
    },
  },
  watch: {
    "$route.query.logistics_code"(value) {
      const code = String(value || "").trim();
      if (code && code !== this.form.logistics_code) {
        this.form.logistics_code = code;
        this.getDetail();
      }
    },
  },
  created() {
    this.form.logistics_code = String(this.$route.query.logistics_code || "").trim();
    this.getConfigInfo();
    if (this.form.logistics_code) {
      this.getDetail();
    } else {
      this.$message({ type: "error", message: "缺少物流码" });
    }
  },
  methods: {
    getConfigInfo() {
      this.$get("logistics", "/configs", { lang: "" })
        .then((res) => {
          this.big_code_name = res.data.big_code_name || this.big_code_name;
          this.middle_code_name = res.data.middle_code_name || this.middle_code_name;
          this.small_code_name = res.data.small_code_name || this.small_code_name;
        })
        .catch(() => {});
    },
    getDetail() {
      const code = this.form.logistics_code;
      if (!code) {
        return;
      }

      this.loading = true;
      this.$get("logistics", "/logistics.search", {
        lang: "",
        logistics_code: code,
      })
        .then((res) => {
          const data = res.data || {};
          const withCodeInfo = data.with_code_info || {};
          this.baseData = data.base_info || {};
          this.codeData = flattenCodeTree(data.code_list);
          this.deliverData = filterLogisticsItems(
            data.logistics_info,
            data.config_info
          );
          this.withCodeInfo.codeSells = Array.isArray(withCodeInfo.code_sells)
            ? withCodeInfo.code_sells
            : [];
          this.withCodeInfo.codeSellsRate = withCodeInfo.code_sells_rate || "";
          this.withCodeInfo.codeSellsDate = withCodeInfo.code_sells_date || {};
          this.isTrue = true;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.isTrue = false;
          this.$message({
            type: "error",
            message: error.message,
          });
        });
    },
    showStack(bigCode) {
      this.stack_logistics_code = bigCode;
      this.stackVisible = true;
    },
    backToSearch() {
      this.$router.replace({
        name: "traceManage",
        query: { logistics_code: this.form.logistics_code },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  .detail-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 20px;
  }

  .small-code-container {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
  }

  .sales-icon {
    width: 24px;
    height: 24px;
    vertical-align: middle;
  }

  .blocknote {
    height: 40px;
    margin: 5px 20px;
    padding-left: 20px;
    background-color: #d3d3d3;
    line-height: 40px;

    span {
      font-size: 18px;
    }
  }

  .page-table {
    padding: 10px 20px;
  }

  .page-table table {
    border-collapse: collapse;
  }

  .page-table th,
  .page-table td {
    padding: 8px;
    border: 1px solid #dbdbdb;
    font-size: 16px;
    font-weight: 400;
    text-align: center;
    word-break: break-all;
  }

  .page-table thead th {
    height: 21px;
    border-color: #fff;
    background: #ccc;
    color: #333;
    font-weight: normal;
  }

  .page-table tbody td {
    height: 16px;
  }

  .logistics-table {
    margin-bottom: 18px;
  }

  .stack {
    padding: 2px 10px;
    border: 1px solid #606255;
    border-radius: 20px;
    color: #606255;
    cursor: pointer;
    font-size: 0.8em;
    transition: all 0.3s;

    &:hover {
      border-color: #b3dcd8;
      background-color: #e6f3f2;
      color: #008b7d;
    }
  }

  .active {
    color: red;
  }

  .normalClass {
    color: #333;
  }

  .empty-data {
    padding: 50px 0;
    color: #909399;
    text-align: center;
  }
}

.last-page td:first-child {
  width: 30%;
}

@media (max-width: 700px) {
  .content .detail-header {
    align-items: flex-start;
    gap: 12px;
  }

  .content .code-table {
    overflow-x: auto;
  }

  .content .code-table table {
    min-width: 760px;
  }
}
</style>
